export default "__VITE_ASSET__74020c5f__"